import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface AgendaConfig {
  instructor_id: string;
  working_days: string[];
  working_hours: Record<string, { start: string; end: string }>;
  default_duration: number;
  is_public: boolean;
  created_at?: string;
  updated_at?: string;
}

export const useUserAgendaConfig = (userId?: string) => {
  const { data: config, isLoading, error } = useQuery({
    queryKey: ['user-agenda-config', userId],
    queryFn: async (): Promise<AgendaConfig | null> => {
      if (!userId) return null;

      // Use the safe RPC function to get any user's agenda config
      const { data, error } = await supabase.rpc('get_instructor_agenda_config_safe', {
        target_instructor_id: userId
      });

      if (error) throw error;

      // Check if data is empty array or null/undefined
      if (!data || (Array.isArray(data) && data.length === 0)) {
        return null; // No configuration found
      }

      // RPC returns an array, so get the first item
      return Array.isArray(data) && data.length > 0 ? data[0] : data;
    },
    enabled: !!userId,
  });

  return {
    config,
    isLoading,
    error: error?.message || null,
  };
};

